module.exports = __webpack_public_path__ + "img/theme_one_audio.afa7a62a.svg";